import React from 'react';
import "../styles/global.css";

function GuestsCount ({ChangeGuests, GuestsCountNumber}) {
    
    const handlePlus = () => {
       ChangeGuests(GuestsCountNumber + 1);
      };

      const handleMinus = () => {
        if (GuestsCountNumber >= 1)
        {
            ChangeGuests(GuestsCountNumber - 1);
        }
        
      };

    return (
        <div className='guest-container'>
            <p>Guests</p>
            <div className='guest-counter-container'>
                <button className='inverted-be-private-button' onClick={handleMinus}>-</button>
                <p>{GuestsCountNumber}</p>
                <button className='inverted-be-private-button' onClick={handlePlus}>+</button>
            </div>
        </div>
        
    );
};

export default GuestsCount;